import * as Yup from "yup";

const teachersValidationSchema = Yup.object().shape({
  firstName: Yup.string().required("Полето е задължително."),
  middleName: Yup.string().required("Полето е задължително."),
  lastName: Yup.string().required("Полето е задължително."),
  firstNameEn: Yup.string().nullable(),
  middleNameEn: Yup.string().nullable(),
  lastNameEn: Yup.string().nullable(),

  email: Yup.string().email("Невалиден имейл адрес.").required("Полето е задължително."),
  egn: Yup.string().required("Полето е задължително."),
  phone: Yup.string().required("Полето е задължително."),

  room: Yup.string().nullable(),

  departmentId: Yup.number().required("Полето е задължително."),

  employmentStartDate: Yup.date().required("Полето е задължително."),
  employmentEndDate: Yup.date().nullable(),

  academicPositionId: Yup.number().required("Полето е задължително."),

  teacherStatusId: Yup.number().required("Полето е задължително."),
});

export default teachersValidationSchema;
